/**
 * Adaptador de `SyncStorage` (de `@fitness/core`) sobre la tabla `syncOps` de
 * Dexie: la cola sobrevive a recargas y a cerrar el navegador.
 */
import type { SyncOp, SyncStorage } from '@fitness/core';
import type { EntityTable } from 'dexie';

export class DexieSyncStorage implements SyncStorage {
  private readonly table: EntityTable<SyncOp, 'id'>;

  constructor(table: EntityTable<SyncOp, 'id'>) {
    this.table = table;
  }

  async getAll(): Promise<SyncOp[]> {
    return this.table.toArray();
  }

  async put(op: SyncOp): Promise<void> {
    await this.table.put(op);
  }

  async remove(id: string): Promise<void> {
    await this.table.delete(id);
  }
}
